import request from '@/utils/request'

// 种草返佣配置API
const grassCommissionApi = {
  detail: '/biz/admin/grass/commission/config/detail',
  save: '/biz/admin/grass/commission/config/save',
}

// 获取返佣配置详情
export function getGrassCommissionConfig() {
  return request({
    url: grassCommissionApi.detail,
    method: 'get'
  })
}

// 保存返佣配置
export function saveGrassCommissionConfig(data) {
  return request({
    url: grassCommissionApi.save,
    method: 'post',
    data: data
  })
}